'use strict';

/* eslint no-undef: "off" */
/**
 * get City Qty
 */
define('getCityQtyApi',['baseApiGet'], function (baseApiGet) {
  return function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return baseApiGet('/rest/V1/xmapi/getCityQty', params);
  };
});
